import cx from "classnames";

import Box from "ds/components/Box";
import TileWrapper from "ds/components/Tile/Wrapper";
import useTypedContext from "hooks/useTypedContext";

import styles from "./styles.module.css";
import BillingTierTile from "../TierTile";
import BillingPlanDetailsTile from "../PlanDetailsTile";
import BillingMarketingTile from "../MarketingTile";
import BillingInvoicingDetailsTile from "../InvoicingDetailsTile";
import BillingUpgradeOptions from "../UpgradeOptions";
import { BillingContext } from "../Context";
import useMarketingTileData from "../MarketingTile/useMarketingTileData";
import { PLAN_FEATURES_BY_TIER } from "../PlanDetailsTile/constants";

const BillingDashboard = () => {
  const { tier, billedExternally, billingSubscription } = useTypedContext(BillingContext);

  const marketingTileData = useMarketingTileData();

  const billingInfo = billingSubscription?.billingInfo;

  const showInvoicingDetails = !!billingInfo && !billedExternally;
  const hasPlanFeatures = !!PLAN_FEATURES_BY_TIER[tier];

  return (
    <Box
      padding="x-large"
      direction="column"
      gap="x-large"
      className={styles.contentWrapper}
      grow="1"
    >
      <TileWrapper grid gridTemplate="1fr 1fr" gap="x-large" padding="x-large" grow="0">
        <BillingTierTile />
        {!!marketingTileData && (
          <BillingMarketingTile
            data={marketingTileData}
            className={cx(hasPlanFeatures !== showInvoicingDetails && styles.takeRightColumn)}
          />
        )}

        <BillingPlanDetailsTile />
        {showInvoicingDetails && (
          <Box direction="column" gap="x-large">
            <BillingInvoicingDetailsTile billingInfo={billingInfo} />
            {/**
             * Don't remove it
             * FYI: We will likely need this tile, so commenting it out for now */}
            {/* <BillingResourcesTile /> */}
          </Box>
        )}
      </TileWrapper>
      <BillingUpgradeOptions />
    </Box>
  );
};

export default BillingDashboard;
